/** @format */

import { useEffect, useState } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import '../BuyersLeads/BuyersLeads.css';
import LeadCountHeader from './LeadCountHeader';
import { Link, useNavigate } from 'react-router-dom';

export default function LeadCount() {
  const [buyerLeads, setBuyerLeads] = useState(0);
  const [sellerLeads, setSellerLeads] = useState(0);
  const [sort, setSort] = useState('desc');
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();


  const fetchBuyerLeads = async (searchTerm: string) => {
    const token = Cookies.get('token');
    try {
      const response = await axios.get('/admin/buyer-lead/', {
        headers: {
          'x-access-token': token,
        },
        params: {
          sortOrder: sort,
          search: searchTerm,
        },
      });
      setBuyerLeads(response.data.total || 0); 
      console.log('Buyer Leads:', response.data.total);
    } catch (err) {
      throw new Error(err.message);
    }
  };

  const fetchSellerLeads = async (searchTerm: string) => {
    const token = Cookies.get('token');
    try {
      const response = await axios.get('/admin/seller-lead/', {
        headers: {
          'x-access-token': token,
        },
        params: {
          sortOrder: sort,
          search: searchTerm,
        },
      });
      setSellerLeads(response.data.total || 0); 
      console.log('Seller Leads:', response.data.total);
    } catch (err) {
      throw new Error(err.message);
    }
  };

  useEffect(() => {
    fetchBuyerLeads(searchTerm);
    fetchSellerLeads(searchTerm);
  }, [sort]);

  const handleSearch = () => {
    fetchBuyerLeads(searchTerm);
    fetchSellerLeads(searchTerm);
  };

  return (
    <div className="Container">
      <LeadCountHeader
        
      />
      <div className="tile-container">
        <div className="tile" onClick={() => navigate('/dashboard/buyers-lead')}>
          <h2>Buyer Leads </h2>
          <p>{buyerLeads}</p>
        </div>
        <div className="tile" onClick={() => navigate('/dashboard/seller-lead')}>
          <h2>Seller Leads </h2>
          <p>{sellerLeads}</p>
        </div>
        <div className="tile" onClick={() => navigate('/dashboard/other-leads')}>
          <h2>Other Leads </h2>
          <p>0</p>
        </div>

        <div className="tile">
          <h2>Total Leads</h2>
          <p>{buyerLeads + sellerLeads}</p>
        </div>
      </div>
      
    </div>

    
  );
}
